<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true"
      >添加商户</el-button
    >
    <el-dialog
      :visible="dialogVisible"
      title="添加商户"
      width="1000px"
      @close="closeDialog"
    >
      <el-form :model="detail" ref="form" :rules="rules" label-width="100px">
        <el-form-item label="用户ID：" prop="userId">
          <el-input v-model="detail.userId"></el-input>
        </el-form-item>
        <el-form-item label="冻结金额：" prop="amount">
          <el-input v-model="detail.amount"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';

export default {
  name: 'setnote',
  data() {
    return {
      dialogVisible: false,
      detail: {},
      rules: {
        id: {
          required: true,
          message: '请填写'
        }
      }
    };
  },
  components: {},
  computed: {},
  methods: {
    ...mapActions('merchant', ['createMerchant']),
    closeDialog() {
      this.dialogVisible = false;
      //   this.detail={};
    },
    handleSave() {
      this.createMerchant(this.detail)
        .then(() => {
          this.$message({
            message: '添加成功',
            type: 'success'
          });
          this.$emit('refresh');
        })
        .finally(() => {
          this.dialogVisible = false;
        });
    }
  }
};
</script>

<style lang="less" scoped></style>
